/**
 * WinningLine Component - SVG overlay for winning line
 */

import React from 'react';

const LINE_COORDS = {
  '0,1,2': { x1: '16.67%', y1: '16.67%', x2: '83.33%', y2: '16.67%' },
  '3,4,5': { x1: '16.67%', y1: '50%', x2: '83.33%', y2: '50%' },
  '6,7,8': { x1: '16.67%', y1: '83.33%', x2: '83.33%', y2: '83.33%' },
  '0,3,6': { x1: '16.67%', y1: '16.67%', x2: '16.67%', y2: '83.33%' },
  '1,4,7': { x1: '50%', y1: '16.67%', x2: '50%', y2: '83.33%' },
  '2,5,8': { x1: '83.33%', y1: '16.67%', x2: '83.33%', y2: '83.33%' },
  '0,4,8': { x1: '16.67%', y1: '16.67%', x2: '83.33%', y2: '83.33%' },
  '2,4,6': { x1: '83.33%', y1: '16.67%', x2: '16.67%', y2: '83.33%' },
};

function WinningLine({ line }) {
  if (!line || line.length !== 3) return null;

  const lineKey = [...line].sort((a, b) => a - b).join(',');
  const coords = LINE_COORDS[lineKey];

  if (!coords) return null;

  return (
    <div className="stt-winning-line">
      <svg className="stt-winning-line__svg" viewBox="0 0 100 100" preserveAspectRatio="none">
        <line
          className="stt-winning-line__line"
          x1={coords.x1}
          y1={coords.y1}
          x2={coords.x2}
          y2={coords.y2}
        />
      </svg>
    </div>
  );
}

export default WinningLine;
